/// <amd-module name="Wit/UI/Card/Components/WorkItemCardContent/WorkItemCardContent" />
import * as React from "react";
import { IWorkItemCardCoreFieldsProps } from "./WorkItemCardContent.Props";

export class WorkItemCardAdditionalFields extends React.Component {
    public render(): JSX.Element {
        const { children } = this.props;

        return <>{children}</>;
    }
}

export class WorkItemCardIdentityRow extends React.Component {
    public render(): JSX.Element {
        const { children } = this.props;

        return <div className="flex-grow flex-row">{children}</div>;
    }
}

export class WorkItemCardCoreFields extends React.Component<IWorkItemCardCoreFieldsProps> {
    public render(): JSX.Element {
        const { children, color } = this.props;

        return (
            <div className="flex-grow flex-column" style={{ backgroundColor: color }}>
                {children}
            </div>
        );
    }
}
